import ManagerDashboard from '../pages/ManagerDashboard';

const perMDViewRoute = {
  public: [],
  auth: [
    {
      name: 'manager_dashboard',
      path: '/manager-dashboard',
      permissions: [
        'KASM',
        'KASOM',
        'KASROM',
        'KASH',
        'SAM',
        'RSM',
        'NSM-SPARTAN',
        'admin',
        'COO',
        'EXECUTIVE',
      ],
      component: ManagerDashboard,
    },
  ],
};

export default perMDViewRoute;
